import { useState, useEffect } from "react";
import CustomAlert from "../Components/MainPages/CustomAlert";

export default function useAlert() {
  const [queue, setQueue] = useState([]); // Alert queue
  const [current, setCurrent] = useState(null); // Currently visible alert

  // Add alert to queue
  const showAlert = (message, type = "success") => {
    if (!message) return;

    // Avoid exact duplicates already in queue
    setQueue((prev) => {
      const duplicate = prev.find((a) => a.message === message);
      if (duplicate) return prev;
      return [...prev, { message, type }];
    });
  };

  // Handle closing current alert
  const handleClose = () => {
    setCurrent(null);
    setQueue((prev) => prev.slice(1));
  };

  // Watch queue and show next alert if none is visible
  useEffect(() => {
    if (!current && queue.length > 0) {
      setCurrent(queue[0]);
    }
  }, [queue, current]);

  // Component to render in JSX
  const AlertComponent = () =>
    current ? (
      <CustomAlert
        message={current.message}
        type={current.type}
        onClose={handleClose}
      />
    ) : null;

  return { showAlert, AlertComponent };
}
